// File utility functions

/**
 * Get the base URL for the application
 * @returns {string} Base URL
 */
export const getBaseURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  return process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';
};

/**
 * Get the full URL for an uploaded file
 * @param {string} filePath - The relative file path
 * @returns {string} Full URL to the file
 */
export const getFileURL = (filePath) => {
  const baseURL = getBaseURL();
  return `${baseURL}${filePath.startsWith('/') ? filePath : '/' + filePath}`;
};

/**
 * Get the URL for an upload file by category and filename
 * @param {string} category - Upload category (e.g., 'topup-proofs', 'payment-proofs')
 * @param {string} filename - The filename
 * @returns {string} Full URL to the file
 */
export const getUploadURL = (category, filename) => {
  return getFileURL(`/uploads/${category}/${filename}`);
};
